/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Components_Featureddiscounts_Countmore2Inputs */

const id_components_featureddiscounts_countmore2 = /** @type {(inputs: Components_Featureddiscounts_Countmore2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} lainnya`)
};

const ms_components_featureddiscounts_countmore2 = /** @type {(inputs: Components_Featureddiscounts_Countmore2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} lagi`)
};

const da_components_featureddiscounts_countmore2 = /** @type {(inputs: Components_Featureddiscounts_Countmore2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} mere`)
};

const de_components_featureddiscounts_countmore2 = /** @type {(inputs: Components_Featureddiscounts_Countmore2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} mehr`)
};

const en_us2_components_featureddiscounts_countmore2 = /** @type {(inputs: Components_Featureddiscounts_Countmore2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} more`)
};

const es_es2_components_featureddiscounts_countmore2 = /** @type {(inputs: Components_Featureddiscounts_Countmore2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} más`)
};

const es_mx2_components_featureddiscounts_countmore2 = /** @type {(inputs: Components_Featureddiscounts_Countmore2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} más`)
};

const fil_components_featureddiscounts_countmore2 = /** @type {(inputs: Components_Featureddiscounts_Countmore2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} pa`)
};

const fr_components_featureddiscounts_countmore2 = /** @type {(inputs: Components_Featureddiscounts_Countmore2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} de plus`)
};

const it_components_featureddiscounts_countmore2 = /** @type {(inputs: Components_Featureddiscounts_Countmore2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} altro`)
};

const hu_components_featureddiscounts_countmore2 = /** @type {(inputs: Components_Featureddiscounts_Countmore2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} további`)
};

const nl_components_featureddiscounts_countmore2 = /** @type {(inputs: Components_Featureddiscounts_Countmore2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} meer`)
};

const no_components_featureddiscounts_countmore2 = /** @type {(inputs: Components_Featureddiscounts_Countmore2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} til`)
};

const pl_components_featureddiscounts_countmore2 = /** @type {(inputs: Components_Featureddiscounts_Countmore2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} więcej`)
};

const pt_br2_components_featureddiscounts_countmore2 = /** @type {(inputs: Components_Featureddiscounts_Countmore2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} more`)
};

const pt_components_featureddiscounts_countmore2 = /** @type {(inputs: Components_Featureddiscounts_Countmore2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} mais`)
};

const ro_components_featureddiscounts_countmore2 = /** @type {(inputs: Components_Featureddiscounts_Countmore2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} mai multe`)
};

const fi_components_featureddiscounts_countmore2 = /** @type {(inputs: Components_Featureddiscounts_Countmore2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} lisää`)
};

const sv_components_featureddiscounts_countmore2 = /** @type {(inputs: Components_Featureddiscounts_Countmore2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} fler`)
};

const vi_components_featureddiscounts_countmore2 = /** @type {(inputs: Components_Featureddiscounts_Countmore2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} khác`)
};

const tr_components_featureddiscounts_countmore2 = /** @type {(inputs: Components_Featureddiscounts_Countmore2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} daha`)
};

const cs_components_featureddiscounts_countmore2 = /** @type {(inputs: Components_Featureddiscounts_Countmore2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} dalších`)
};

const bg_components_featureddiscounts_countmore2 = /** @type {(inputs: Components_Featureddiscounts_Countmore2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} още`)
};

const ru_components_featureddiscounts_countmore2 = /** @type {(inputs: Components_Featureddiscounts_Countmore2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ещё +${i?.count}`)
};

const uk_components_featureddiscounts_countmore2 = /** @type {(inputs: Components_Featureddiscounts_Countmore2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} ще`)
};

const ar_components_featureddiscounts_countmore2 = /** @type {(inputs: Components_Featureddiscounts_Countmore2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} المزيد`)
};

const hi_components_featureddiscounts_countmore2 = /** @type {(inputs: Components_Featureddiscounts_Countmore2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} और`)
};

const th_components_featureddiscounts_countmore2 = /** @type {(inputs: Components_Featureddiscounts_Countmore2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} เพิ่มเติม`)
};

const ja_components_featureddiscounts_countmore2 = /** @type {(inputs: Components_Featureddiscounts_Countmore2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} 件`)
};

const zh_cn2_components_featureddiscounts_countmore2 = /** @type {(inputs: Components_Featureddiscounts_Countmore2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} more`)
};

const zh_hant1_components_featureddiscounts_countmore2 = /** @type {(inputs: Components_Featureddiscounts_Countmore2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} more`)
};

const ko_components_featureddiscounts_countmore2 = /** @type {(inputs: Components_Featureddiscounts_Countmore2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} more`)
};

/**
* | output |
* | --- |
* | "+{count} more" |
*
* @param {Components_Featureddiscounts_Countmore2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_featureddiscounts_countmore2 = /** @type {((inputs: Components_Featureddiscounts_Countmore2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Featureddiscounts_Countmore2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_featureddiscounts_countmore2(inputs)
	if (locale === "ms") return ms_components_featureddiscounts_countmore2(inputs)
	if (locale === "da") return da_components_featureddiscounts_countmore2(inputs)
	if (locale === "de") return de_components_featureddiscounts_countmore2(inputs)
	if (locale === "en-US") return en_us2_components_featureddiscounts_countmore2(inputs)
	if (locale === "es-ES") return es_es2_components_featureddiscounts_countmore2(inputs)
	if (locale === "es-MX") return es_mx2_components_featureddiscounts_countmore2(inputs)
	if (locale === "fil") return fil_components_featureddiscounts_countmore2(inputs)
	if (locale === "fr") return fr_components_featureddiscounts_countmore2(inputs)
	if (locale === "it") return it_components_featureddiscounts_countmore2(inputs)
	if (locale === "hu") return hu_components_featureddiscounts_countmore2(inputs)
	if (locale === "nl") return nl_components_featureddiscounts_countmore2(inputs)
	if (locale === "no") return no_components_featureddiscounts_countmore2(inputs)
	if (locale === "pl") return pl_components_featureddiscounts_countmore2(inputs)
	if (locale === "pt-BR") return pt_br2_components_featureddiscounts_countmore2(inputs)
	if (locale === "pt") return pt_components_featureddiscounts_countmore2(inputs)
	if (locale === "ro") return ro_components_featureddiscounts_countmore2(inputs)
	if (locale === "fi") return fi_components_featureddiscounts_countmore2(inputs)
	if (locale === "sv") return sv_components_featureddiscounts_countmore2(inputs)
	if (locale === "vi") return vi_components_featureddiscounts_countmore2(inputs)
	if (locale === "tr") return tr_components_featureddiscounts_countmore2(inputs)
	if (locale === "cs") return cs_components_featureddiscounts_countmore2(inputs)
	if (locale === "bg") return bg_components_featureddiscounts_countmore2(inputs)
	if (locale === "ru") return ru_components_featureddiscounts_countmore2(inputs)
	if (locale === "uk") return uk_components_featureddiscounts_countmore2(inputs)
	if (locale === "ar") return ar_components_featureddiscounts_countmore2(inputs)
	if (locale === "hi") return hi_components_featureddiscounts_countmore2(inputs)
	if (locale === "th") return th_components_featureddiscounts_countmore2(inputs)
	if (locale === "ja") return ja_components_featureddiscounts_countmore2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_featureddiscounts_countmore2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_featureddiscounts_countmore2(inputs)
	return ko_components_featureddiscounts_countmore2(inputs)
});
export { components_featureddiscounts_countmore2 as "components.featuredDiscounts.countMore" }